<template>
  <div class="timeDetail">
    <el-dialog :visible.sync="dialogVisible" width="590px" :before-close="handleClose" :show-close="false" :modal-append-to-body="false" class="Hierarchy">
      <div slot="title" class="alertHeader dialogHeader">
        <img loading="lazy" class="cursorPoint dialogClose-header-img" v-lazy="require('../../static/image/pn/login-close2.png')" @click="handleClose" />
        <div class="alertTitle dialogTitles">{{signIn.limitTime}}</div>
      </div>
      <div class="header-title">
        <p class="title-text">{{pageData.name}}</p>
        <p class="time-text" v-if="pageData.forever == 0">{{pageData.startTime |timeFilter}} - {{pageData.endTime |timeFilter}}</p>
        <p class="time2-text tradingButtons" v-if="pageData.forever == 1">{{signIn.long}}</p>
        <div class="content">
          <el-scrollbar style="height:4.7rem;padding-right:2px">
            <div v-html="pageData.intro" class="">

            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      pageData: ''
    }
  },
  computed: {
    signIn() {
      return this.$t('signIn')
    }
  },
  filters: {
    timeFilter: function (value) {
      var timestamp4 = new Date(value);
      return timestamp4.toLocaleDateString().replace(/\//g, "-") + " " + timestamp4.toTimeString().substr(0, 8);
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    }
  },
}
</script>

<style lang="scss" >
.timeDetail {
  // @import "../../assets/css/eldialog.scss";
  .Hierarchy {
    z-index: 9999;
  }
  .header-title {
    text-align: left;
  }

  .title-text {
    color: #2d2b4d;
    font-size: 0.2rem;
    text-align: left;
  }
  .time-text {
    color: #9695a6;
    font-size: 0.15rem;
    text-align: left;
    line-height: 2;
  }
  .time2-text {
    border-radius: 10px;
    display: inline-block;
    padding: 0px 10px;
    font-size: 0.12rem;
    /* text-align: left; */
    line-height: 1.5;
  }
  .content {
    border-top: 1px solid #f4f4f4;
    margin-top: 17px;
    padding-top: 16px;
    text-align: left;
  }
}
</style>